import { __extends } from "tslib";
import React, { Component } from 'react';
import { FormFooterWrapper } from './styled/FormFooter';
var FormFooter = /** @class */ (function (_super) {
    __extends(FormFooter, _super);
    function FormFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFooter.prototype.render = function () {
        var _a = this.props, align = _a.align, children = _a.children;
        return React.createElement(FormFooterWrapper, { align: align }, children);
    };
    FormFooter.defaultProps = {
        align: 'end',
    };
    return FormFooter;
}(Component));
export default FormFooter;
//# sourceMappingURL=FormFooter.js.map